import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Row, Col, Popover, OverlayTrigger } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import uniqBy from 'lodash/uniqBy';

import { Select } from 'sa-ui';
import { promisify } from 'app/actions';

import ComposingCorrectionUploadEssaySheetModal from './ComposingCorrectionUploadEssaySheetModal';
import ComposingUploadConfirmationModal from './ComposingUploadConfirmationModal';
import ComposingCorrectionTermsOfUseModal from './ComposingCorrectionTermsOfUseModal';
import ComposingCorrectionAnswerList from './ComponsingCorrectionAnswerList';

import * as classStudentActions from '../../classes-students/classesStudentsActions';
import { getGroups } from '../simulatedActions';
import * as actions from './composingCorrectionActions';

import * as helpers from '../simulatedHelpers';

import messages from './composingCorrectionMessages';

import './ComposingCorrectionContainer.scss';

function ComposingCorrectionContainer(props) {
  const [modal, setModal] = useState({});
  const [filter, setFilter] = useState({});
  const [student, setStudent] = useState();
  const [singularFile, setSingularFile] = useState(false);
  const [filesUploaded, setFilesUploaded] = useState([]);
  const [error, setError] = useState([]);
  const [errorCount, setErrorCount] = useState(0);

  useEffect(() => {
    const idCSchool = JSON.parse(localStorage.getItem('idCSchool'));
    const idESCourse = JSON.parse(localStorage.getItem('idESCourse'));
    setFilter({ ...filter, idCSchool, idESCourse });

    if (idESCourse) {
      props.getStudentAnswerList({
        idCSchool: filter.idCSchool,
        idESCourse: filter.idESCourse,
        idEvaluation: props.idEvaluation,
      });
    }
  }, [props.groups]);

  useEffect(() => {
    props.getGroups({ idEvaluation: props.idEvaluation });
    props.getEvaluationInformation({ idEvaluation: props.idEvaluation });
  }, [props.idEvaluation]);

  useEffect(() => {
    if (singularFile) {
      setUploadCardsModal(true);
    }
  }, [props.singularFile]);

  const toggleModal = (name, visible) => () => {
    setModal({ ...modal, [name]: visible });
  };

  function handleChangeSchool(event) {
    setFilter({ ...filter, idCSchool: event.target.value, idESCourse: undefined });
    if (event.target.value !== '') {
      localStorage.setItem('idCSchool', JSON.stringify(event.target.value));
    } else {
      localStorage.removeItem('idCSchool');
    }
    localStorage.removeItem('idESCourse');
  }

  function handleChangeIdESCourse(event) {
    setFilter({ ...filter, idESCourse: event.target.value });
    props.getStudentAnswerList({
      idCSchool: filter.idCSchool,
      idESCourse: event.target.value,
      idEvaluation: props.idEvaluation,
    });
    if (event.target.value !== '') {
      localStorage.setItem('idESCourse', JSON.stringify(event.target.value));
    } else {
      localStorage.removeItem('idESCourse');
    }
  }

  function handleUploadStudent(student) {
    setStudent(student);
    setSingularFile(true);
    toggleModal('termsOfUse', true)();
  }

  const schoolOptions = uniqBy(props.groups, (g) => g.idCSchool).map((g) => ({
    value: g.idCSchool,
    label: g.schoolName,
  }));

  const courseOptions = helpers.getCourseOptions(props.groups, filter.idCSchool);

  if (props.forbidden) {
    return <FormattedMessage {...messages.forbidden} />;
  }

  if (props.forbidden === undefined) {
    return null;
  }

  function handleError(error) {
    if (error) {
      setError(error);
      setErrorCount(errorCount + 1);
    }
  }

  return (
    <div>
      <div className="row align-items-end">
        <div className="col-md-6">
          <a className="return" onClick={props.history.goBack}>
            <i className="ti-arrow-left"> </i> <FormattedMessage {...messages.back} />
          </a>
          <FormattedMessage {...messages.title}>
            {(txt) => <h5 className="title">{txt}</h5>}
          </FormattedMessage>
          <h6 className="subtitle">
            {props.evaluation.evaluation.levelSegment.map((l) => (
              <div>{l}</div>
            ))}
            <div>{props.contract.application}</div>
          </h6>
        </div>
      </div>
      <Row className="align-items-center">
        <Col lg={2}>
          <h6 className="id mb-0">
            <div>
              {props.evaluation.evaluation.catalogings.map((c) => c.abbreviation).join(' | ')}
            </div>
            <div>ID: {props.evaluation.evaluation.idString}</div>
          </h6>
        </Col>
        <Col lg={2}>
          <Select
            containerClassName="mt-0"
            options={schoolOptions}
            nullable
            onChange={handleChangeSchool}
            placeholder={props.intl.formatMessage(messages.school)}
            value={filter.idCSchool}
          />
        </Col>
        <Col lg={2}>
          <Select
            containerClassName="mt-0"
            disabled={!filter.idCSchool}
            nullable
            options={courseOptions}
            onChange={handleChangeIdESCourse}
            placeholder={props.intl.formatMessage(messages.class)}
            value={filter.idESCourse}
          />
        </Col>
      </Row>
      <Row className="justify-content-between">
        <Col>
          <FormattedMessage {...messages.correctionMethod}>
            {(txt) => <h3 className="title mt-5 mb-1">{txt}</h3>}
          </FormattedMessage>
          <FormattedMessage {...messages.choiceInfo}>{(txt) => <p>{txt}</p>}</FormattedMessage>
        </Col>
      </Row>

      <div className="row">
        <div className="col-md-4">
          <div className={classNames('card h-100 card-school pb-5 correction-card')}>
            <div className="card-body">
              <FormattedMessage {...messages.sendCardsSubtitle}>
                {(txt) => <div className="card-title text-danger">{txt}</div>}
              </FormattedMessage>
              <FormattedMessage {...messages.sendCardsInfo}>
                {(txt) => <p>{txt}</p>}
              </FormattedMessage>
              {!filter.idESCourse ? (
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Popover id="popover-needClickBefore">
                      <Popover.Body>
                        <span className="popover-correction">
                          <FormattedMessage {...messages.needClickBefore} />
                        </span>
                      </Popover.Body>
                    </Popover>
                  }
                >
                  <button type="button" className="btn btn-block btn-primary">
                    <FormattedMessage {...messages.loadCardsButton} />
                  </button>
                </OverlayTrigger>
              ) : (
                <button
                  type="button"
                  className="btn btn-block btn-primary"
                  onClick={toggleModal('termsOfUse', true)}
                >
                  <FormattedMessage {...messages.loadCardsButton} />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      {props.students.length > 0 && (
        <Row className="mt-3">
          <Col md={12}>
            <ComposingCorrectionAnswerList
              students={props.students}
              onUpload={handleUploadStudent}
            />
          </Col>
        </Row>
      )}
      <ComposingCorrectionUploadEssaySheetModal
        show={modal.uploadCardsModal}
        idEvaluation={props.idEvaluation}
        idCSchool={filter.idCSchool}
        idESCourse={filter.idESCourse}
        onClose={() => {
          setModal({ uploadCardsModal: false });
          setSingularFile(false);
          props.getStudentAnswerList({
            idCSchool: filter.idCSchool,
            idESCourse: filter.idESCourse,
            idEvaluation: props.idEvaluation,
          });
        }}
        onCompleteUpload={(files) => {
          setFilesUploaded(files);
          toggleModal('uploadConfirmation', true)();
        }}
        singularFile={singularFile}
        onError={(error) => handleError(error)}
        student={student}
      />
      <ComposingUploadConfirmationModal
        isOpen={modal.uploadConfirmation}
        singularFile={singularFile}
        onClose={() => {
          setModal({ ...modal, uploadConfirmation: false });
          setSingularFile(false);
          setErrorCount(0);
          setError([]);
        }}
        onContinue={() => {
          setModal({ ...modal, uploadConfirmation: false });
          setSingularFile(false);
          setErrorCount(0);
          setError([]);
        }}
        error={props.correctComposingSheetState.error || error}
        errorCount={errorCount}
        amount={filesUploaded.length}
      />
      <ComposingCorrectionTermsOfUseModal
        show={modal.termsOfUse}
        onClose={() => {
          toggleModal('termsOfUse', false)();
          setSingularFile(false);
        }}
        onContinue={() => {
          setModal({ termsOfUse: false, uploadCardsModal: true });
          props.setLoading(false);
        }}
      />
    </div>
  );
}

ComposingCorrectionContainer.defaultProps = {
  students: [],
};
function mapStateToProps({ composingCorrection, simulated, classesStudents }, { match }) {
  return {
    ...composingCorrection,
    ...match.params,
    classesStudents,
    groups: simulated.groups,
    isLoading: simulated.isLoading,
  };
}

export default compose(
  injectIntl,
  withRouter,
  connect(
    mapStateToProps,
    promisify(
      {
        ...actions,
        ...classStudentActions,
        getGroups,
      },
      {
        include: ['uploadEvaluationEssayCard'],
      },
    ),
  ),
)(ComposingCorrectionContainer);
